import { Injectable } from '@angular/core';

type Point = { x: number; y: number };

type Rect = {
  id: string;
  points: Point[]; // 4 punti in ordine (antiorario)
};

type Edge = {
  a: Point;
  b: Point;
  rectId: string;
};

type ConcaveCorner = {
  point: Point;
  rectId: string;
};

@Injectable({
  providedIn: 'root'
})


export class AngolicelleirregolariService {

  private rects: Rect[]=[];
  private perimeterEdges: Edge[] = [];
 
  constructor() { }


  /** Metodo pubblico principale */
  findConcaveCorners(rects: Rect[]): ConcaveCorner[] {

    this.rects = rects;
    const edges = this.collectEdges();

    this.perimeterEdges = this.buildPerimeter(edges);
    return this.detectConcaveCorners();
  }

  // ---------- STEP 1: estrazione spigoli ----------
  private collectEdges(): Edge[] {
    const allEdges: Edge[] = [];

    for (const r of this.rects) {
      r.points.forEach((p, i) => {
        allEdges.push({
          a: p,
          b: r.points[(i + 1) % r.points.length],
          rectId: r.id
        });
      });
    }

    return this.removeInternalEdges(allEdges);
  }

  // ---------- STEP 2: rimozione spigoli interni ----------
  private removeInternalEdges(edges: Edge[]): Edge[] {
    const map = new Map<string, Edge | null>();

    for (const e of edges) {
      const k = this.edgeKey(e);
      map.set(k, map.has(k) ? null : e);
    }

    return [...map.values()].filter(
      (e): e is Edge => e !== null
    );
  }

  private edgeKey(e: Edge): string {
    const p1 = `${e.a.x},${e.a.y}`;
    const p2 = `${e.b.x},${e.b.y}`;
    return p1 < p2 ? `${p1}-${p2}` : `${p2}-${p1}`;
  }

  // ---------- STEP 3: ordinamento perimetro ----------
  private buildPerimeter(edges: Edge[]): Edge[] {
    if (edges.length === 0) return [];

    const ordered: Edge[] = [edges[0]];
    let current = edges[0].b;

    while (true) {
      const next = edges.find(
        e => e.a.x === current.x && e.a.y === current.y
      );
      if (!next) break;

      ordered.push(next);
      current = next.b;

      if (
        current.x === ordered[0].a.x &&
        current.y === ordered[0].a.y
      ) break;
    }

    return ordered;
  }

  // ---------- STEP 4: rilevamento rientranze ----------
  private detectConcaveCorners(): ConcaveCorner[] {
    const concave: ConcaveCorner[] = [];
    const p = this.perimeterEdges;

    for (let i = 0; i < p.length; i++) {
      const prev = p[(i - 1 + p.length) % p.length];
      const curr = p[i];

      const v1 = this.vec(prev.b, prev.a);
      const v2 = this.vec(curr.a, curr.b);

      if (
        this.cross(v1, v2) < 0 &&
        prev.rectId === curr.rectId
      ) {
        concave.push({
          point: curr.a,
          rectId: curr.rectId
        });
      }
    }

    return concave;
  }

  // ---------- Math helpers ----------
  private vec(a: Point, b: Point): Point {
    return { x: b.x - a.x, y: b.y - a.y };
  }

  private cross(a: Point, b: Point): number {
    return a.x * b.y - a.y * b.x;
  }
}
